/**
 *    @param serviceManager  客服管理（售后管理）
 *    @param serviceShare    客服公用加手机设备
 *    @param overseasService 海外客服
 *    @param produceManager  生产组
 *    @param domesticSales   国内销售
 *    @param foreignSales    海外销售
 *    @param exploit         开发（研发）
 *    @param admin           所有权限
 */
import Vue from "vue";

export function getRole(arr) {
  if (sessionStorage.getItem("role")) {
    let role = sessionStorage.getItem("role").split(",");
    if (role.indexOf("admin") > -1) {
      return ["admin"];
    } else {
      return role.filter(function(n) {
        return arr.indexOf(n) != -1;
      });
    }
  } else {
    return [];
  }
}
// 序列号
export function mobileEquip() {
  const mobileEquip = {
    // updatedBtn: ["overseasService", "produceManager", "exploit"],
    updateInfodBtn: ["serviceManager", "serviceShare", "overseasService"],
    addBtn: ["produceManager"],
    // 序列号:生产，售后管理，海外客服
    productID: ["produceManager", "serviceManager", "overseasService"],
    // 经销商:国内销售，生产，售后管理，海外客服
    traderName: ["domesticSales", "produceManager", "serviceManager", "overseasService"],
    // 语言:研发部（下拉选择）
    lang: ["produceManager", "foreignSales", "overseasService"],
    // 售机类型:生产，客服管理， 海外客服
    productName: ["produceManager", "overseasService",'serviceManager'],
    // 激活类型:客服管理，客服公用，海外客服
    activetype: ["serviceManager", "serviceShare", "overseasService"],
    // 备注:生产部，国内销售，客服管理，客服公用（基本上所有用户都需要修改），海外客服
    remark: [
      "produceManager",
      "domesticSales",
      "foreignSales",
      "exploit",
      "overseasService",
      "serviceShare",
      "serviceManager"
    ],
    // 已激活次数:，海外客服
    activityTimes: ["overseasService"],
    // 订单号:：生产部
    orderNo: ["produceManager"],
    // 启用:客服管理，客服公用，国内销售，海外客服
    status: [
      "serviceManager",
      "serviceShare",
      "domesticSales",
      "overseasService"
    ],
    // 绑定、姓名、手机、地址、省/市/县
    // 首次激活时间:客服管理，海外客服
    activityDate: ["serviceManager", "foreignSales"],
    // 免费年限：海外客服
    free: ["overseasService"],
    // 过期日期：海外客服
    expireDate: ["overseasService"],
    // 国家/地区：海外客服
    regionName: ["overseasService"]
    // 下载区域限制
  };
  let mobileEquipArr = {};
  for (let x in mobileEquip) {
    mobileEquipArr[x] = getRole(mobileEquip[x]).length > 0 ? true : false;
  }
  return mobileEquipArr;
}
// 订单
export function orderPower() {
  const orderPower = {
    // 添加按钮：生产部
    addBtn: ["produceManager"],
    // 查看按钮：查看订单下的序列号列表权限
    lookSnBtn: ["produceManager", "serviceManager", "overseasService"],
    // 修改按钮：查看列表
    updatedBtn: ["produceManager"]
  };
  let list = {};
  for (let x in orderPower) {
    list[x] = getRole(orderPower[x]).length > 0 ? true : false;
  }
  return list;
}
// 业务员
export function salerPower() {
  const salerPower = {
    addBtn: ["domesticSales", "foreignSales"],
    updatedBtn: ["overseasService", "domesticSales", "foreignSales"]
  };
  let list = {};
  for (let x in salerPower) {
    list[x] = getRole(salerPower[x]).length > 0 ? true : false;
  }
  return list;
}
// 经销商
export function lockMachine() {
  const lockMachine = {
    addBtn: ["domesticSales", "foreignSales"],
    updatedBtn: [
      "serviceManager",
      "overseasService",
      "domesticSales",
      "foreignSales"
    ]
  };
  let list = {};
  for (let x in lockMachine) {
    list[x] = getRole(lockMachine[x]).length > 0 ? true : false;
  }
  return list;
}
// 注册用户
export function member() {
  const member = {
    // updatedBtn: ["serviceShare"],
    // resetPossword: ["serviceManager", "serviceShare"]
    updatedBtn: [],
    resetPossword: []
  };
  let list = {};
  for (let x in member) {
    list[x] = getRole(member[x]).length > 0 ? true : false;
  }
  return list;
}
// 下载区域
export function downRegion() {
  const downRegion = {
    addBtn: ["overseasService"],
    updatedBtn: ["overseasService"]
  };
  let list = {};
  for (let x in downRegion) {
    list[x] = getRole(downRegion[x]).length > 0 ? true : false;
  }
  return list;
}
// 车型管理 直接再页面操作

// 海外经销商锁机
export function lockAuth() {
  const lockAuth = {
    lookList: ["overseasService", "foreignSales"],
    updatedBtn: ["overseasService"]
  };
  let list = {};
  for (let x in lockAuth) {
    list[x] = getRole(lockAuth[x]).length > 0 ? true : false;
  }
  return list;
}

// 设备管理productInfo
export function equipManage() {
  const equipManage = {
    productInfoUpdatedBtn: ["exploit", "produceManager"],
    // 平板序列号已归属到mobileEquip中 这个不使用
    mobileEquipUpdatedBtn: ["exploit", "produceManager"]
  };
  let list = {};
  for (let x in equipManage) {
    list[x] = getRole(equipManage[x]).length > 0 ? true : false;
  }
  return list;
}

// 设备管理productInfo
export function lang() {
  const lang = {
    addBtn: ["exploit"],
    updatedBtn: ["overseasService", "produceManager", "foreignSales"]
  };
  let list = {};
  for (let x in lang) {
    list[x] = getRole(lang[x]).length > 0 ? true : false;
  }
  return list;
}


// WEBPACK FOOTER //
// ./src/utils/constant.js